import { render, staticRenderFns } from "./questionnaireTitle.vue?vue&type=template&id=986a7f32&scoped=true&"
import script from "./questionnaireTitle.vue?vue&type=script&lang=js&"
export * from "./questionnaireTitle.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireTitle.vue?vue&type=style&index=0&id=986a7f32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986a7f32",
  null
  
)

export default component.exports